import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { signup } from 'api/auth';
import { useFeedback } from 'contexts/feedback';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function UsersCreate() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const cache = useQueryClient();
    const navigate = useNavigate();
    const { setSuccess } = useFeedback();

    const { mutate: create } = useMutation({
        mutationKey: ['createUser'],
        mutationFn: signup,
        onSuccess: (data) => {
            cache.invalidateQueries(['users']);
            setSuccess("Utente creato con successo");
            return navigate(`/users/${data.data._id}/edit`);
        },
        onError: (error) => {
            console.error("Error creating user:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const data = {
            firstname: e.target.firstname.value,
            lastname: e.target.lastname.value,
            email: e.target.email.value,
            password: e.target.password.value
        }

        create({data});
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Crea nuovo utente</p>
                    </div>

                    <div className=''>
                        <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                            <div className='flex gap-4'>
                                <TextInput
                                    label="Nome"
                                    name="firstname"
                                    placeholder="Nome"
                                    required
                                />
                                <TextInput
                                    label="Cognome"
                                    name="lastname"
                                    placeholder="Cognome"
                                    required
                                />
                            </div>
                            <TextInput
                                label="Email"
                                name="email"
                                type="email"
                                placeholder="Email"
                                required
                            />
                            <TextInput
                                label="Password"
                                name="password"
                                type="password"
                                placeholder="Password"
                                required
                            />
                            <TextInput
                                label="Conferma Password"
                                name="confirmPassword"
                                type="password"
                                placeholder="Conferma Password"
                                required
                            />

                            <div className='flex justify-between pt-6'>
                                <Link to="/settings/users" className='hover:bg-grey text-white text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button submit>Salva e crea</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
